var app = angular.module('leonardo');

var RuleSelector = function (ngDialog, FilterService) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      filter: '@',
      name: '@',
      inline: '=',
      placeholder: '@',
      options: '='
    },
    templateUrl: 'views/templates/widget/rule-selector.html',
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];
      scope.formCtrl = scope.$parent.Form ? scope.$parent.Form : { $submitted: true };
      scope.value = null;
      scope.dynamic_filters = [];
      scope.defaultValues = [];
      scope.init = false;

      scope.placeholder = !isNull(scope.placeholder) ? scope.placeholder : 'Select Rules';

      scope.options_rules = [];

      scope.ngModelCtrl.$render = function () {
        scope.dynamic_filters = angular.copy(scope.ngModelCtrl.$viewValue);
        if (isNull(scope.dynamic_filters) && scope.filter) {
          scope.dynamic_filters = FilterService.getFilter(scope.filter);
        }
        scope.dynamic_filters = !isNull(scope.dynamic_filters) ? scope.dynamic_filters : [];
        var defaultValues = [];
        angular.forEach(scope.dynamic_filters, function (dynamic) {
          defaultValues.push(dynamic.id);
        });
        scope.defaultValues = defaultValues.join(',');
      };

      scope.initOptionsRules = function () {
        var options = [];
        angular.forEach(scope.options, function (option) {
          options.push({ id: option.id, name: option.label });
        });
        scope.options_rules = options;
      };

      scope.showDynamicRules = function () {
        if (!scope.disabled) {
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/widget/add-rule.html',
              controller: 'RulesDialog',
              className: 'ngdialog-theme-default ngdialog-schedules',
              data: {
                dynamicFieldsArray: scope.options,
                dynamic_filters: scope.dynamic_filters
              },
              showClose: false
            })
            .then(function (data) {
              scope.dynamic_filters = data;
            }, function () {
              return;
            });
        }
      };

      scope.$watch('dynamic_filters', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init) {
          scope.ngModelCtrl.$setViewValue(newValue);
          if (scope.filter) {
            FilterService.setFilter(scope.filter, scope.dynamic_filters);
          }
          if (scope.init) {
            var values = [];
            angular.forEach(scope.dynamic_filters, function (filter) {
              values.push(filter.id);
            });
            scope.value = values.join(',');
          }
          scope.init = true;
        }
      });

      scope.$watch('options', function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue) || !scope.init) {
          scope.initOptionsRules();
        }
      });

      scope.ngModelCtrl.$validators.required = function (modelValue) {
        if (!scope.required) {
          return true;
        }
        return !isEmpty(modelValue);
      };

      scope.initOptionsRules();
    }
  };
};
var RulesDialog = function ($scope, FormErrorsService, ReportService, FilterService) {
  $scope.dynamicFieldsArray = angular.copy($scope.ngDialogData.dynamicFieldsArray);
  $scope.dynamic_filters = angular.copy($scope.ngDialogData.dynamic_filters);

  $scope.conditions = ReportService.CONDITIONS;
  $scope.lookupTypes = ReportService.LOOKUP_TYPES;

  $scope.isTextField = function (field) {
    return _.contains(
      [
        'textInput',
        'poneInput',
        'textArea',
        'numberInput',
        'pmsPropertyId',
        'currencyInput',
        'propertyName',
        'propertyAddress',
        'propertyInfo',
        'starRate',
        'sliderRange',
        'userName',
        'unitNumber',
        'unitBuilding',
        'unitInfo',
        'tenantId'
      ],
      field.component
    );
  };

  $scope.isCheckboxField = function (field) {
    return _.contains(['checkbox', 'checkboxJustifiedLeft'], field.component);
  };

  $scope.isSelectField = function (field) {
    return _.contains(['select', 'radio', 'radioJustifiedLeft', 'ratingScale3pt'], field.component);
  };

  $scope.isDateField = function (field) {
    return _.contains(['dateInput', 'dateTimeInput', 'timeInput'], field.component);
  };

  $scope.isFileField = function (field) {
    return _.contains(['fileImageInput', 'fileInput', 'imageInput', 'imageMultipleInput', 'signatureInput', 'fileEmbedded'], field.component);
  };

  $scope.containsDynamicFilter = function (field) {
    var index = -1;
    angular.forEach($scope.dynamic_filters, function (value, key) {
      if (value.id == field.id) {
        index = key;
      }
    });
    return index;
  };

  $scope.isSelected = function (field) {
    return $scope.containsDynamicFilter(field) >= 0;
  };

  $scope.toggleFilter = function (field) {
    if ($scope.containsDynamicFilter(field) >= 0) {
      $scope.dynamic_filters.splice($scope.containsDynamicFilter(field), 1);
    } else {
      $scope.dynamic_filters.push({ id: field.id, groupId: field.groupId, value: null, lookup_type: null, condition: null, optionId:null });
    }
  };

  $scope.getLookupTypes = function (field) {
    var array = [];
    angular.forEach($scope.lookupTypes, function (type) {
      switch (field.component) {
        case 'textInput':
        case 'phoneInput':
        case 'textArea':
        case 'propertyName':
        case 'pmsPropertyId':
        case 'propertyAddress':
        case 'propertyInfo':
        case 'userName':
        case 'unitNumber':
        case 'unitBuilding':
        case 'unitInfo':
        case 'tenantId':
        case 'starRate':
        case 'sliderRange':
          if (_.contains([ReportService.LOOKUP_TYPE_EQ, ReportService.LOOKUP_TYPE_CONTAINS], type.id.toString())) {
            array.push(type);
          }
          break;
        case 'checkbox':
        case 'checkboxJustifiedLeft':
          if (ReportService.LOOKUP_TYPE_CONTAINS == type.id) {
            array.push(type);
          }
          break;
        case 'select':
        case 'radio':
        case 'radioJustifiedLeft':
        case 'fileImageInput':
        case 'fileInput':
        case 'fileEmbedded':
        case 'imageInput':
        case 'imageMultipleInput':
        case 'signatureInput':
        case 'ratingScale3pt':
          if (ReportService.LOOKUP_TYPE_EQ == type.id) {
            array.push(type);
          }
          break;
        case 'numberInput':
        case 'currencyInput':
          if (ReportService.LOOKUP_TYPE_HAS_KEYS != type.id) {
            array.push(type);
          }
          break;
        case 'dateInput':
        case 'dateTimeInput':
        case 'timeInput':
          if (!_.contains([ReportService.LOOKUP_TYPE_HAS_KEYS, ReportService.LOOKUP_TYPE_CONTAINS], type.id.toString())) {
            array.push(type);
          }
          break;
      }
    });
    return array;
  };

  $scope.initLookupType = function (field) {
    if (!$scope.dynamic_filters[$scope.containsDynamicFilter(field)].lookup_type) {
      if ($scope.getLookupTypes(field).length > 0) {
        $scope.dynamic_filters[$scope.containsDynamicFilter(field)].lookup_type = $scope.getLookupTypes(field)[0].id;
      }
    }
  };

  $scope.initCondition = function (field) {
    if (!$scope.dynamic_filters[$scope.containsDynamicFilter(field)].condition) {
      $scope.dynamic_filters[$scope.containsDynamicFilter(field)].condition = $scope.conditions[0].id;
    }
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if (isEmpty($scope.dynamic_filters)) {
      FilterService.removeFilter('dynamic_filters');
    } else {
      FilterService.setFilter('dynamic_filters', $scope.dynamic_filters);
    }

    //add optionId in $scope.dynamic_filters
    $scope.dynamic_filters.forEach(filter => {
      filter.optionId = $scope.dynamicFieldsArray
        .filter(field => filter.id === field.id && filter.groupId === field.groupId && typeof filter.value === 'string')
        .flatMap(field => filter.value.split(',').map(Number).map(val => field.optionsArray[val]?.id))
        .filter(Boolean)
        .join(',');
    });
    
    
    $scope.confirm($scope.dynamic_filters);
  };
};

app.directive('ruleSelector', ['ngDialog', 'FilterService', RuleSelector]);
app.controller('RulesDialog', ['$scope', 'FormErrorsService', 'ReportService', 'FilterService', RulesDialog]);
